<template>
	<template v-if="data">
		<section>
			<ButtonBack />

			<h1>{{ data.title }}</h1>
			<span>{{ $formatDate(data.publishedDate) }}</span>

			<TheBox :title="'Beschwerde:'">
				<div class="text">{{ data.text }}</div>
			</TheBox>

			<TheBox :title="'Entscheidung:'" v-if="data.notResponsibleReason || data.reasonText">
				<div v-if="data.caseState" :class="`has-status has-status--${$getStateColor('case', data.caseState)}`">
					{{ $getStateFullLabel('case', data.caseState, false) }}
				</div>
				<div v-else :class="`has-status has-status--${$getStateColor('complaint', ComplaintState.NotResponsible)}`">
					{{ $getStateFullLabel('complaint', ComplaintState.NotResponsible, false) }}
				</div>

				<h3>Begründung</h3>
				<div v-if="data.notResponsibleReason">{{ data.notResponsibleReason }}</div>
				<div v-else-if="data.reasonText" class="text">{{ data.reasonText }}</div>
			</TheBox>

			<!-- Wird nur gezeigt, wenn token in der Url dabei ist und mit  -->
			<TheBox :title="'Information für Beschwerdeführer:'" v-if="data.notResponsibleRelevantAuthority && token">
				<div>{{ data.notResponsibleRelevantAuthority }}</div>
			</TheBox>
		</section>
	</template>
	<section v-else-if="loading === false">
		<ButtonBack />
		<el-alert :title="texts.general.emptyText" type="error" effect="dark" :closable="false" />
	</section>
</template>

<script lang="ts">
import ButtonBack from '@/components/buttons/ButtonBack.vue';
import TheBox from '@/components/TheBox.vue';
import { getPublicComplaint } from '@/requests/complaints';
import { startLoading, stopLoading } from '@/utils/loading/loadingHandler';
import type { FormInstance } from 'element-plus';
import { defineComponent, ref } from 'vue';
import { ComplaintPublicResponse, ComplaintState } from '../types/types';
import { texts } from '../utils/texts';

export default defineComponent({
	name: 'BeschwerdeDetailPublicView',
	data() {
		return {
			data: null as ComplaintPublicResponse | null,
			loading: true,
			ComplaintState,
		};
	},
	props: {
		id: {
			type: String,
			required: true,
		},
	},
	components: {
		ButtonBack,
		TheBox,
	},
	setup() {
		const formRef = ref<FormInstance | null>(null);

		return {
			formRef,
		};
	},
	computed: {
		texts() {
			return texts;
		},
		token() {
			return this.$route.query.token as string;
		},
	},
	methods: {
		async loadComplaint() {
			const loading = startLoading('#beschwerde');

			const result = await getPublicComplaint(this.id, this.token);
			if (result.success) {
				this.data = result.data;
			}
			this.loading = false;
			stopLoading(loading);
		},
	},
	mounted() {
		this.loadComplaint();
	},
});
</script>

<style lang="scss" scoped>
#beschwerde {
	.box {
		margin-top: 3rem;

		h3 {
			margin-top: 2rem;
		}

		&:last-child {
			margin-bottom: 3rem;
		}
	}
}
</style>
